import { LanguageEnum } from 'modules/common/enums';

export const CategoryLibraryIdByLanguage: { [key in LanguageEnum]: number } = {
	[LanguageEnum.ENGLISH]: 1,
	[LanguageEnum.HEBREW]: 378,
	[LanguageEnum.YIDDISH]: 96,
};
